module.exports = __webpack_public_path__ + "img/leirintäalue_original.7aaf6355.jpg";